var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isQrcodeIndex)?_c('QrcodeConfirmedIndex'):(!_vm.isMobile)?_c('app-pc'):_c('app-mobile')}
var staticRenderFns = []

export { render, staticRenderFns }